import type { ProseData, SectionStatus } from '../../types/canvas';
import { ActionBar } from './ActionBar';

interface HeroCardProps {
  data: ProseData;
  status: SectionStatus;
  meta?: string;
  onApprove?: () => void;
  onRefine?: () => void;
  onAnother?: () => void;
  refineDisabled?: boolean;
}

export function HeroCard({ data, status, meta, onApprove, onRefine, onAnother, refineDisabled }: HeroCardProps) {
  return (
    <div className="col-span-full bg-surface border border-border border-l-[3px] border-l-primary rounded-lg p-6 sm:px-7">
      <p className="font-display text-lg italic leading-relaxed text-foreground [font-variation-settings:'opsz'_48,'SOFT'_80] mb-3">
        {data.prose}
      </p>
      {meta && (
        <p className="text-xs text-muted-foreground">
          <strong className="text-foreground font-medium">{meta}</strong>
        </p>
      )}
      <ActionBar status={status} onApprove={onApprove} onRefine={onRefine} onAnother={onAnother} refineDisabled={refineDisabled} />
    </div>
  );
}
